( function( $ ) {

    'use strict';
    
    /**
     *  Override so we can style better.
     */
    var $override = function( target, message ) {
        var $target = $( target );
        $( '.wpcf7-not-valid-tip', $target ).remove();
        var $this = $( '<span role="alert" class="wpcf7-not-valid-tip"></span>' )
            .text( message ).appendTo( $target );

        $('<span class="icon__bang"></span>').prependTo($this);

        if ( $target.is( '.use-floating-validation-tip *' ) ) {
            var fadeOut = function( target ) {
                $( target ).not( ':hidden' ).animate( {
                    opacity: 0
                }, 'fast', function() {
                    $( this ).css( { 'z-index': -100 } );
                } );
            };

            $target.on( 'mouseover', '.wpcf7-not-valid-tip', function() {
                fadeOut( this );
            } );

            $target.on( 'focus', ':input', function() {
                fadeOut( $( '.wpcf7-not-valid-tip', $target ) );
            } );
        }
    };

    $(document).ready(function() {
        window.wpcf7
            window.wpcf7.notValidTip = $override;
    });

} )( jQuery );


// WEBPACK FOOTER //
// ./tbo/js/util/cf7.js